import { useMutation } from 'react-query';
import { changePassword } from './ChangePassword.requests';
export var useChangePassword = function () {
    return useMutation({
        mutationFn: changePassword,
    });
};
